module.exports = __webpack_public_path__ + "img/dxsrfh.462b3c5e.png";